// The threeDi.org API returns UUIDs with dashes, but the 3Di API expects them without dashes. This function converts a UUID from the threeDi.org format to the 3Di format.
export const convertThreediOrg = (uuid: string) => {
  return uuid.replace(/-/g, "");
};
